
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {Prop} from 'vue-property-decorator';
  import {TimelineModel} from '@/models/timeline.model';
  import moment from 'moment';

  @Component({})
  export default class TimelineItemCard extends Vue {
    @Prop({required: true}) model!: TimelineModel;


    formatDate(date: string): string {
      return moment(date).format('MMM. D YYYY, HH:mm a').toString()
    }
  }
